import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';

import './style.scss';

const InputIcon = ({ icon, onChange, ...props }) => {
  const handleChange = ({ target: { value } }) => {
    onChange(value);
  };

  return (
    <div className="input-group">
      <div className="input-icon">
        <Icon name={icon} />
      </div>
      <input {...props} className="input withIcon" onChange={handleChange} />
    </div>
  );
};

InputIcon.propTypes = {
  icon: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

InputIcon.defaultProps = {
  icon: 'search',
};

export { InputIcon };
